// myth_questions.ts
import { QuestionProps } from "./components/Quiz";
import { translations } from "./translations/translations";
import { Language } from "./context/LanguageContext";

export const getAllQuestions = (language: Language): QuestionProps[][] => {
  const t = translations[language].quiz;

  return [
    [
      {
        id: 1,
        type: "yes-no",
        question: t.question1,
        answer: "NEIN", // so wie du es hattest, kein t.no
        explanation: "",
      },
      {
        id: 2,
        type: "multiple-choice",
        question: t.question2,
        options: [t.q2option1, t.q2option2, t.q2option3],
        answer: t.q2answer,
        explanation: t.q2explanation,
      },
      {
        id: 3,
        type: "slider",
        question: t.question3,
        answer: 30,
        explanation: t.q3explanation,
        min: 0,
        max: 100,
      },
    ],
    [
      {
        id: 1,
        type: "yes-no",
        question: t.question4,
        answer: "NEIN",
      },
      {
        id: 2,
        type: "multiple-choice",
        question: t.question5,
        options: [t.q5option1, t.q5option2, t.q5option3],
        answer: t.q5answer,
        explanation: t.q5explanation,
      },
      {
        id: 3,
        type: "slider",
        question: t.question6,
        answer: 30,
        explanation: t.q6explanation,
        min: 0,
        max: 100,
      },
    ],
    [
      {
        id: 1,
        type: "yes-no",
        question: t.question7,
        answer: "NEIN",
      },
      {
        id: 2,
        type: "multiple-choice",
        question: t.question8,
        options: [t.q8option1, t.q8option2, t.q8option3],
        answer: t.q8answer,
        explanation: t.q8explanation,
      },
      {
        id: 3,
        type: "slider",
        question: t.question9,
        min: 0,
        max: 100,
        answer: 49,
        explanation: t.q9explanation,
      },
    ],
  ];
};
